var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"depressed":"","outlined":"","dense":"","color":"primary lighten-1"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"size":"16"}},[_vm._v(" fa-solid fa-chevron-left ")]),_vm._v(" "+_vm._s(_vm.$t(`general.returnBackBtn`))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }